const PROXIED_ENVS = ["staging", "integration", "uat", "production"];
const REQUIRES_DOMAIN_PATHS = /(linkedin_connect|oauth)/;
const BARE_HOSTNAME = /^[a-z0-9.-]+$/i;

const isBareHostname = (host: string): boolean => BARE_HOSTNAME.test(host) && !host.includes("..");

export const ApiRoute = (
  path: string,
  { relative = false, accountDomain }: { relative?: boolean; accountDomain?: string } = {}
) => {
  if (accountDomain) {
    if (!isBareHostname(accountDomain)) {
      throw new Error(`ApiRoute received an invalid accountDomain: ${accountDomain}`);
    }
    return `https://${accountDomain}${path}`;
  }
  if (
    relative ||
    (!!window.PF.config.environment &&
      PROXIED_ENVS.indexOf(window.PF.config.environment) >= 0 &&
      !REQUIRES_DOMAIN_PATHS.test(path))
  ) {
    return path;
  }
  return `${window.PF.config.api_endpoint}${path}`;
};

export const AtlasRoute = (path: string): string => {
  if (!!window.PF.config.environment && PROXIED_ENVS.indexOf(window.PF.config.environment) >= 0) {
    const wsProtocol = location.protocol === "https:" ? "wss:" : "ws:";
    const prefix = window.PF.config.atlas_prefix ?? "";
    return `${wsProtocol}//${location.host}${prefix}${path}`;
  }
  return `${window.PF.config.atlas_endpoint ?? ""}${path}`;
};

export const UiRoute = (path: string, hostname = window.location.hostname, port = window.location.port) => {
  if (!path) {
    throw new Error("UiRoute called without path");
  }

  // If the URL does not contain an explicit port number, port will be set to '',
  // so we can skip it in the route
  return port
    ? `${location.protocol}//${hostname}:${port}${path}`
    : `${location.protocol}//${hostname}${path}`;
};
